import axios from 'axios'
import { BUSCAR_TOMADORES } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';
import { montarURLFiltro } from '../../../util/filtros';

export default function buscarTomadores (idEmpresa, pagina, registrosPorPagina, filtros) {
    const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina)
  let url = `${URL}/tomador/empresa/${idEmpresa}/recuperar/${urlFiltros}`;

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_TOMADORES,
        payload: response

      })
  );
}
